import {
  type CountryDetail,
  CountryDetailSchema,
  type CountryListQuery,
  type CountryListResponse,
  CountryListResponseSchema,
  type CreateCountryRequest,
  type UpdateCountryRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Country master API. Every response is validated with the shared Zod schema.
 */

export const listCountries = async (query: CountryListQuery): Promise<CountryListResponse> => {
  const { data } = await apiClient.get<unknown>('/countries', { params: query });
  return CountryListResponseSchema.parse(data);
};

export const getCountry = async (id: string): Promise<CountryDetail> => {
  const { data } = await apiClient.get<unknown>(`/countries/${id}`);
  return CountryDetailSchema.parse(data);
};

export const createCountry = async (payload: CreateCountryRequest): Promise<CountryDetail> => {
  const { data } = await apiClient.post<unknown>('/countries', payload);
  return CountryDetailSchema.parse(data);
};

export const updateCountry = async (
  id: string,
  payload: UpdateCountryRequest,
): Promise<CountryDetail> => {
  const { data } = await apiClient.patch<unknown>(`/countries/${id}`, payload);
  return CountryDetailSchema.parse(data);
};

export const deleteCountry = async (id: string): Promise<void> => {
  await apiClient.delete(`/countries/${id}`);
};

export const bulkDeleteCountries = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/countries/bulk-delete', { ids });
  return data;
};

export const bulkSetCountriesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/countries/bulk-set-status', { ids, isActive });
  return data;
};
